import React from 'react';
import PropTypes from 'prop-types';

const AiOopsMessage = ({
	message = 'Oops! Something went wrong.',
	centered = false,
}) => (
	<div className={`my-3 ${centered && 'text-center'}`}>
		{message}
	</div>
);

export default AiOopsMessage;

AiOopsMessage.propTypes = {
	message: PropTypes.string,
	centered: PropTypes.bool,
};
